import PicturesApp from 'station/components/picture/PicturesApp'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitle } from 'utils/StationUtils'

const ResourcePicturesApp = ({

}) => {
    const {
        resource,
        resources,
    } = useSelector(store => ({
        resource: store.ResourceReducer.resource,
        resources: store.ResourceReducer.resources,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.resource,
        href: 'resource',
    }, {
        title: getStationTitle(resource),
        href: `station/resource/${resource?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/resource/${resource?.id}/picture`,
    }], [resource])

    return (
        <PicturesApp
            stations={resources}
            station={resource}
            stationType='resource'
        />
    )
}

export default ResourcePicturesApp